module.exports = __webpack_public_path__ + "static/media/domestic-project.32963952.png";